import React, { useState } from "react";
import showAlert from "../../../server/ShowAlert";
import { validateCoupon } from "../../../server/Coupon";
import "./CouponCode.scss";

const CouponCode = ({ userId, orderSum, onCouponApplied }) => {
  const [couponCode, setCouponCode] = useState("");
  const [isApplying, setIsApplying] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      showAlert({ msgTitle: "נא להזין קוד קופון", msgType: "error" });
      return;
    }

    setIsApplying(true);

    validateCoupon(couponCode, userId)
      .then((response) => {
        if (response.Success) {
          if (orderSum < response.Coupon.MinOrder) {
            showAlert({
              msgTitle: `הסכום המינימלי לשימוש בקופון זה הוא ₪${response.Coupon.MinOrder}`,
              msgType: "error",
            });
            setAppliedCoupon(null);
          } else {
            const discount = response.Coupon.Sum;
            setAppliedCoupon({
              code: couponCode,
              discount: discount,
            });
            onCouponApplied(discount, couponCode);
            showAlert({ msgTitle: "הקופון הוחל בהצלחה!", msgType: "success" });
          }
        } else {
          const errorMsg = response.Message || "קוד הקופון אינו תקין";
          showAlert({ msgTitle: errorMsg, msgType: "error" });
          setAppliedCoupon(null);
          onCouponApplied(0, null);
        }
        setIsApplying(false);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.Message ||
          error.response?.message ||
          "קוד הקופון אינו תקין";
        showAlert({ msgTitle: errorMsg, msgType: "error" });
        setAppliedCoupon(null);
        onCouponApplied(0, null);
        setIsApplying(false);
      });
  };

  const handleRemoveCoupon = () => {
    setCouponCode("");
    setAppliedCoupon(null);
    onCouponApplied(0, null);
  };

  return (
    <section className="coupon-code-section">
      <div className="coupon-window">
        <div className="coupon-form">
          {!appliedCoupon ? (
            <div className="coupon-input-area">
              <input
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                placeholder="הזן קוד קופון"
                className="coupon-text-input"
                disabled={isApplying}
              />
              <button
                onClick={handleApplyCoupon}
                disabled={isApplying || !couponCode.trim()}
                className="btn-apply-coupon"
              >
                {isApplying ? "בודק..." : "החל קופון"}
              </button>
            </div>
          ) : (
            <div className="coupon-applied-area">
              <div className="applied-info">
                <span className="applied-code">
                  קופון: {appliedCoupon.code}
                </span>
                <span className="applied-discount">
                  הנחה: ₪{appliedCoupon.discount.toFixed(2)}
                </span>
              </div>
              <button
                onClick={handleRemoveCoupon}
                className="btn-remove-coupon"
              >
                הסר קופון
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CouponCode;
